import { render, staticRenderFns } from "./SettingsScopevisio.vue?vue&type=template&id=2e85033c&scoped=true&"
import script from "./SettingsScopevisio.vue?vue&type=script&lang=ts&"
export * from "./SettingsScopevisio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85033c",
  null
  
)

export default component.exports